/* 🤖 this file was generated by svg-to-ts */
export const iconMkr: {
  name: 'mkr';
  data: string;
} = {
  name: 'mkr',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#maker__clip0_298_617)"><path fill="currentColor" fill-rule="evenodd" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m-.29 22.5h-1.84v-6.08l-6.03-4.37v10.44H6v-14l9.71 7.03zm10.29 0h-1.84V12.06l-6.03 4.37v6.08h-1.84v-6.97L26 8.51v14z" clip-rule="evenodd"/></g><defs><clipPath id="maker__clip0_298_617"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
